import Api from "../helpers/api";

export const vratConfigVrstvy = async () => {
  try {
    const response = await Api.get(`/api/v1/smartmap/config_layers`);
    return response.data ? response.data : false;
  } catch (error) {
    return false;
  }
};
